<template>
  <div>
    <commonModal
      :show="showWarningModal"
      :options="{
        title: 'Sorry!',
        description: `Unfortunately we cannot insure vehicles used for business purposes.`,
        buttonLabel: 'OK'
      }"
      @close="showWarningModal = false"
    ></commonModal>
    <commonModal
      :show="showMileageModal"
      :options="{
        title: 'Notice',
        description:
          'We will quote your vehicle based on 13,000 annual miles; however, your premium will still be charged based on the actual miles you drive.',
        buttonLabel: 'OK'
      }"
      @close="
        showMileageModal = false;
        mileageModalShown = true;
      "
    >
    </commonModal>
    <form class="has-placeholders">
      <fieldset>
        <legend v-if="vehicleStepIndex === 0">{{ name }}</legend>
        <legend v-if="vehicleStepIndex > 0">Additional Vehicle</legend>
        <div class="vehicle">
          <div
            class="columns is-variable is-8-widescreen"
            v-for="(vehicle, index) in form.vehicles"
            v-bind:key="index"
          >
            <div
              class="column is-half padd-bottom-0"
              v-if="index === vehicleStepIndex"
            >
              <label class="input -spacing-static-c">
                <input
                  :class="{
                    input__field: true,
                    error:
                      errors.has('vin' + vehicle.id) ||
                      (vehicle.vin && vehicle.isVINValid === false)
                  }"
                  :name="'vin' + vehicle.id"
                  type="text"
                  v-on:change="searchVin(vehicleStepIndex)"
                  placeholder="VIN"
                  v-model="vehicle.vin"
                  v-validate="'required|alpha_num|length:17'"
                  data-vv-validate-on="input|blur"
                  @input="vinInput"
                />
                <span class="input__label">VIN</span>
              </label>
              <div
                v-if="
                  errors.has('vin' + vehicle.id) &&
                    vehicle.vin &&
                    vehicle.vin.length != 17
                "
                class="vin-error-text"
              >
                The VIN must be 17 characters. Please try again.
              </div>
              <label class="input -spacing-static-c">
                <label
                  :for="'year' + vehicle.id"
                  :class="{
                    textFieldLabel: true,
                    error: errors.has('year')
                  }"
                  >Year</label
                >
                <div
                  :class="{
                    input__field: true,
                    div__field: true,
                    error: errors.has('year')
                  }"
                  :disabled="true"
                >
                  {{ vehicle.year }}
                </div>
              </label>

              <label class="input -spacing-static-c">
                <label
                  :for="'make' + vehicle.id"
                  :class="{
                    textFieldLabel: true,
                    error: errors.has('make')
                  }"
                  >Make</label
                >
                <div
                  :class="{
                    input__field: true,
                    div__field: true,
                    error: errors.has('year')
                  }"
                  :disabled="true"
                >
                  {{ vehicle.make }}
                </div>
              </label>

              <label class="input -spacing-static-c">
                <label
                  :for="'model' + vehicle.id"
                  :class="{
                    textFieldLabel: true,
                    error: errors.has('model')
                  }"
                  >Model</label
                >
                <div
                  :class="{
                    input__field: true,
                    div__field: true,
                    error: errors.has('year')
                  }"
                  :disabled="true"
                >
                  {{ vehicle.model }}
                </div>
              </label>

              <label class="input -spacing-static-c">
                <label
                  :for="'style' + vehicle.id"
                  :class="{
                    textFieldLabel: true,
                    error: errors.has('style')
                  }"
                  >Style</label
                >
                <div
                  :class="{
                    input__field: true,
                    div__field: true,
                    error: errors.has('year')
                  }"
                  :disabled="true"
                >
                  {{ vehicle.style }}
                </div>
              </label>
            </div>

            <div
              class="column is-half padd-top-0"
              v-if="index === vehicleStepIndex"
            >
              <div class="select-wrapper -spacing-static-c">
                <label
                  :for="'priorDamage' + vehicle.id"
                  :class="{
                    dropDownLabel: true,
                    error: errors.has('priorDamage' + vehicle.id)
                  }"
                  >Does this vehicle have existing damage?</label
                >
                <v-select
                  v-model="vehicle.priorDamage"
                  :searchable="false"
                  placeholder
                  :options="selectsVehicles.priorDamage"
                  :name="'priorDamage' + vehicle.id"
                  :class="{ error: errors.has('priorDamage' + vehicle.id) }"
                  v-validate="'required'"
                ></v-select>
              </div>

              <div class="select-wrapper -spacing-static-c">
                <label
                  :for="'leaseOwnFinance' + vehicle.id"
                  :class="{
                    dropDownLabel: true,
                    error: errors.has('leaseOwnFinance' + vehicle.id)
                  }"
                  >Is your vehicle owned, leased, or financed?</label
                >
                <v-select
                  v-model="vehicle.leaseOwnFinance"
                  :searchable="false"
                  placeholder
                  :options="selectsVehicles.leaseOwnFinance"
                  :name="'leaseOwnFinance' + vehicle.id"
                  :class="{ error: errors.has('leaseOwnFinance' + vehicle.id) }"
                  v-validate="'required'"
                ></v-select>
              </div>

              <div
                v-if="lengthOfOwnershipState"
                class="select-wrapper -spacing-static-c"
              >
                <label
                  :for="'lengthOfOwnership' + index"
                  :class="{
                    dropDownLabel: true,
                    error: errors.has('lengthOfOwnership' + index)
                  }"
                  >How long have you owned your vehicle?</label
                >
                <v-select
                  v-model="vehicle.lengthOfOwnership"
                  :searchable="false"
                  placeholder
                  :options="selectsVehicles.ownershipLength"
                  :name="'lengthOfOwnership' + index"
                  :class="{
                    error: errors.has('lengthOfOwnership' + index)
                  }"
                  v-validate="'required'"
                ></v-select>
              </div>

              <div class="select-wrapper -spacing-static-c">
                <label
                  :for="'purpose' + vehicle.id"
                  :class="{
                    dropDownLabel: true,
                    error: errors.has('purpose' + vehicle.id)
                  }"
                  >What is your vehicle’s primary use?</label
                >
                <v-select
                  v-model="vehicle.purpose"
                  :searchable="false"
                  placeholder
                  :options="
                    selectedState === 'PA'
                      ? purposesSelect
                      : selectsVehicles.purposes
                  "
                  v-validate="'required'"
                  @input="quotePurposeChange(vehicleStepIndex)"
                  :name="'purpose' + vehicle.id"
                  :class="{ error: errors.has('purpose' + vehicle.id) }"
                  data-vv-validate-on="input|blur"
                ></v-select>
              </div>

              <label class="input -spacing-static-c" v-show="vehicle.showMiles">
                <input
                  :class="{
                    input__field: true,
                    error: errors.has('milesAnnually' + vehicle.id)
                  }"
                  :name="'milesAnnually' + vehicle.id"
                  placeholder="How Many Miles Do You Drive Annually?"
                  v-model="vehicle.miles"
                  v-validate="vehicle.showMiles ? 'required|numeric' : ''"
                  @input="onlyNumbers"
                  @paste="onPaste($event, 7)"
                  @keypress="onlyNumberLimitedToNDigits($event, 7)"
                  data-vv-validate-on="input|blur"
                />
                <span class="input__label"
                  >How many miles do you drive annually?
                </span>
                <!-- <i class="icon icon--info tool-tip primary-use-info-icon">
                  <div class="content">
                    <p>Your annual mileage cannot exceed 11,500 miles</p>
                    <i></i>
                  </div>
                </i> -->
              </label>
              <label class="input -spacing-static-c">
                <masked-input
                  :class="{
                    input__field: true,
                    error: errors.has('value-amount' + vehicle.id)
                  }"
                  type="text"
                  :name="'value-amount' + vehicle.id"
                  placeholder="Insured Value"
                  v-model="vehicle.statedValue"
                  @input="
                    checkValueAmount(
                      'value-amount' + vehicle.id,
                      vehicle.statedValue
                    )
                  "
                  @blur="
                    checkValueAmount(
                      'value-amount' + vehicle.id,
                      vehicle.statedValue,
                      'blur'
                    )
                  "
                  :keepCharPositions="false"
                  v-validate="'required|insuredValueValidator'"
                  :mask="numberMask"
                  :guide="false"
                  data-vv-validate-on="input|blur"
                ></masked-input>
                <span class="input__label">Insured Value</span>
              </label>
              <div class="help -spacing-static-c value-amount-text">
                How should I choose this amount?
                <i class="icon icon--info tool-tip">
                  <div class="content">
                    <p>
                      This is the amount we will pay in the event of a covered
                      total loss. If your vehicle is financed or leased, ensure
                      this amount covers your outstanding balance. The insured
                      value amount must be between $1,000 and $300,000.
                    </p>
                    <i></i>
                  </div>
                </i>
              </div>
            </div>
          </div>
        </div>
        <div class="button-right-align">
          <button
            @click="backButtonNavigation"
            type="button"
            v-if="currentStepNumber > 1 && currentStepNumber < 5"
            class="button-primary button-primary--black -spacing-static-b back-button"
          >
            <span class="button-primary__icon icon icon--arrow-right-hair">
              <span class="loader-base button-primary__loader"></span>
            </span>

            <span class="button-primary__label">Back</span>
          </button>

          <button
            @click="continueButtonNavigation"
            type="button"
            class="button-primary button-primary--black -spacing-static-b your-vehicle"
            v-if="currentStepNumber !== 7"
            :disabled="disableContinueButton"
          >
            <span class="button-primary__icon icon icon--arrow-right-hair">
              <span class="loader-base button-primary__loader"></span>
            </span>

            <span class="button-primary__label">
              {{ isLastStep ? 'Submit' : 'Continue' }}
            </span>
          </button>
          <button
            @click="addVehicle"
            type="button"
            class="button-primary button-primary--black -spacing-static-b another-vehicle-button"
            v-if="!hasMaximum && vehicleStepIndex + 1 === form.vehicles.length"
            :disabled="disableContinueButton"
          >
            <span class="button-primary__icon icon icon--arrow-right-hair">
              <span class="loader-base button-primary__loader"></span>
            </span>

            <span class="button-primary__label">Add Another Vehicle</span>
          </button>
          <button
            @click="removeVehicle(vehicleStepIndex)"
            v-if="form.vehicles.length > 1 && vehicleStepIndex > 0"
            type="button"
            class="button-primary button-primary--black -spacing-static-b remove-vehicle"
          >
            <span class="button-primary__icon icon icon--arrow-right-hair">
              <span class="loader-base button-primary__loader"></span>
            </span>

            <span class="button-primary__label">Remove Vehicle</span>
          </button>
        </div>
        <div v-if="hasMaximum">
          <p class="has-maximum">
            Please call
            <a :href="'tel:1-' + $phoneNumber">{{ $phoneNumber }}</a> and speak
            with an agent in order to add more vehicles.
          </p>
        </div>
      </fieldset>
    </form>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapMutations } from 'vuex';
import { canUseAdvertising, safeGtag } from '@/utils/tracking';
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import commonModal from '../shared/commonModal';
import * as _ from 'lodash';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

axios.defaults.withCredentials = true;

let id = 1;

export default {
  props: {
    wizardData: {
      type: Object,
      required: true
    },
    currentStepNumber: {
      type: Number
    },
    isLastStep: {
      type: Boolean
    }
  },

  components: {
    commonModal
  },

  data: () => ({
    currentVehicleId: null,
    payload: {
      state: null,
      year: null,
      make: null,
      model: null,
      bodyStyle: null
    },
    name: 'Your Vehicle',
    purposesSelect: [
      {
        label: 'Commute to NJ or NY.',
        value: 'COMMUTE NY/NJ'
      },
      {
        label: 'Personal',
        value: 'Pleasure'
      },
      {
        label: 'Business',
        value: 'Business'
      }
    ],
    form: {
      vehicles: [
        {
          id: id,
          vin: null,
          year: null,
          model: null,
          style: null,
          purpose: null,
          isUnlimited: false,
          miles: null,
          priorDamage: null,
          leaseOwnFinance: null,
          showMiles: false,
          isVINValid: null,
          statedValue: null,
          lengthOfOwnership: null
        }
      ]
    },
    vinData: null,
    maximum: 4,
    hasMaximum: false,
    vehicleStepIndex: 0,
    showWarningModal: false,
    showMileageModal: false,
    mileageModalShown: false,
    disableContinueButton: false,
    vehicleImgBaseUrl: process.env.VUE_APP_PORSCHE_PIC_BASE_URL
  }),
  computed: {
    ...mapGetters(['quoteForm', 'selectsVehicles']),
    lengthOfOwnershipState() {
      return (
        this.selectedState === 'AZ' ||
        this.selectedState === 'OH' ||
        this.selectedState === 'PA' ||
        this.selectedState === 'TN' ||
        this.selectedState === 'WI'
      );
    },
    selectedState() {
      if (
        this.quoteForm.info.garagingState &&
        this.quoteForm.info.isGarageSameAsMailing.value !== 1
      ) {
        return _.cloneDeep(this.quoteForm.info.garagingState.value);
      }
      return this.quoteForm.info.state
        ? _.cloneDeep(this.quoteForm.info.state.value)
        : '';
    },
    numberMask() {
      return createNumberMask({
        prefix: '$',
        integerLimit: 6
      });
    }
  },
  mounted() {
    this.floodlightVehicles();
    switch (this.selectedState) {
      case 'AZ':
      case 'OH':
      case 'PA':
      case 'TN':
      case 'WI':
        this.form.vehicles.forEach(veh => {
          if (!(veh && veh.lengthOfOwnership)) {
            veh.lengthOfOwnership = null;
          }
        });
        break;
      default:
        break;
    }
    if (!_.isEmpty(this.quoteForm.vehicles)) {
      this.form.vehicles = _.cloneDeep(this.quoteForm.vehicles);
      this.vehicleStepIndex =
        this.form.vehicles && this.form.vehicles.length - 1;
    }
  },
  created: function() {
    this.payload.state = this.quoteForm.info.state
      ? this.quoteForm.info.state.value
      : '';
  },
  methods: {
    ...mapMutations(['updateForm']),
    ...mapActions(['getVehicleImage', 'requestVinCheck']),
    floodlightVehicles() {
      if (
        process.env.VUE_APP_ENV.toLowerCase() !== 'production' &&
        process.env.VUE_APP_ENV.toLowerCase() !== 'prod'
      ) {
        return;
      } else if (!canUseAdvertising()) {
        return;
      } else {
        // console.log('2025 Floodlight 2 Active');
        // Porsche PAI Receive a quote Form Continue Button 2.Your vehicle
        let flDiv = document.body.appendChild(document.createElement('div'));
        let GDPR = '${GDPR}';
        let GDPR_CONSENT_755 = '${GDPR_CONSENT_755}';
        flDiv.setAttribute('id', process.env.VUE_APP_FLOODLIGHT_ID);
        flDiv.style.position = 'absolute';
        flDiv.style.top = '0';
        flDiv.style.left = '0';
        flDiv.style.width = '1px';
        flDiv.style.height = '1px';
        flDiv.style.display = 'none';
        flDiv.innerHTML = `
            <img src="https://ad.doubleclick.net/ddm/activity/src=5368208;type=2025p0;cat=porsc000;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1?" width="1" height="1" alt=""/>
          `;
        if (process.env.VUE_APP_GOOGLE_ANALYTICS === 'enable') {
          safeGtag('advertising', 'event', 'conversion', {
            allow_custom_scripts: true,
            send_to: 'DC-5368208/2025p0/porsc000+standard'
          });
        }
      }
    },
    onlyNumberLimitedToNDigits($event, numberOfDigits = 5) {
      if ($event.target.value.length >= numberOfDigits) {
        $event.preventDefault();
      }
    },
    onPaste(event, maxValue) {
      event.clipboardData.getData('text/plain').slice(0, maxValue);
    },
    onlyNumbers() {
      this.form.vehicles[this.vehicleStepIndex].miles = this.form.vehicles[
        this.vehicleStepIndex
      ].miles
        .toString()
        .replace(/[^0-9]/g, '');
    },
    setVehicleId(vehicleId) {
      this.currentVehicleId = vehicleId;
    },
    vinCheckAPI(index) {
      const API_URL = process.env.VUE_APP_API_URL;
      return new Promise((resolve, reject) => {
        axios
          .post(
            API_URL + 'vin/check',
            JSON.stringify({
              vin: this.form.vehicles[index].vin,
              state: this.payload.state ? this.payload.state : ''
            }),
            {
              withCredentials: true,
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              responseType: 'json'
            }
          )
          .then(resp => {
            this.vinData = resp.data;
            this.form.vehicles[index].isVINValid = true;
            this.form.vehicles[index].year = this.vinData.year;
            this.form.vehicles[index].make = this.vinData.make;
            this.form.vehicles[index].style = this.vinData.bodyStyle;
            this.form.vehicles[index].model = this.vinData.model;
            this.form.vehicles[index].isVINValid = !this.checkForDuplicateVIN(
              index
            );
            if (!this.form.vehicles[index].isVINValid) {
              this.showSnackbarForDuplicateVin();
            }
            resolve(true);
          })
          .catch(err => {
            if (err.response.status === 404) {
              this.form.vehicles[index].isVINValid = false;
              this.form.vehicles[index].year = null;
              this.form.vehicles[index].make = null;
              this.form.vehicles[index].style = null;
              this.form.vehicles[index].model = null;
              this.showSnackBar({
                type: 'is-danger',
                message: 'Invalid VIN',
                position: 'is-bottom'
              });
            }
            const tnError =
              err.response &&
              err.response.error_messages &&
              err.response.error_messages[0].includes('orsche');
            const errMessage = tnError
              ? 'We are unable to insure non-Porsche vehicles in this state.'
              : 'Invalid VIN / Cannot locate vehicle';

            this.showSnackBar({
              type: 'is-danger',
              message: errMessage,
              position: 'is-bottom',
              indefinite: true
            });
            reject(false);
          });
      });
    },
    searchVin(index) {
      let firstErrorField = null;
      this.$validator
        .validate('vin' + (index + 1), this.form.vehicles[index].vin)
        .then(result => {
          if (result) {
            if (this.checkForDuplicateVIN(index)) {
              this.form.vehicles[index].isVINValid = false;
              this.showSnackbarForDuplicateVin();
            } else {
              if (
                this.form.vehicles[index].vin &&
                this.form.vehicles[index].vin.length === 17
              ) {
                this.vinCheckAPI(index);
              }
            }
          } else {
            setTimeout(() => {
              firstErrorField = this.$el.querySelector(
                '[name="' + this.$validator.errors.items[0].field + '"]'
              );
              firstErrorField.focus();
            }, 50);
          }
        });
    },
    quotePurposeChange(index) {
      const selectedPurpose = { ...this.form.vehicles[index].purpose };
      if (
        selectedPurpose.value === 'Pleasure' ||
        selectedPurpose.value === 'Commute'
      ) {
        this.form.vehicles[index].showMiles = true;
      } else {
        this.form.vehicles[index].showMiles = false;
      }
    },
    addVehicle() {
      this.scrollToView();
      let that = this;
      if (
        this.checkBusinessSelected(this.form.vehicles[this.vehicleStepIndex])
      ) {
        return;
      }
      if (
        this.form.vehicles[this.vehicleStepIndex].miles > 13000 &&
        !this.mileageModalShown
      ) {
        this.mileageModalShown = true;
        this.showMileageModal = true;
        return;
      }
      this.$validator.validateAll().then(result => {
        if (result && that.form.vehicles[that.vehicleStepIndex].isVINValid) {
          if (that.form.vehicles.length < that.maximum) {
            that.form.vehicles.push({
              id: id + 1,
              vin: null,
              year: null,
              model: null,
              style: null,
              purpose: null,
              isUnlimited: false,
              miles: null,
              priorDamage: null,
              leaseOwnFinance: null,
              showMiles: false,
              isVINValid: null,
              statedValue: null
            });
            that.vehicleStepIndex++;
          } else {
            that.hasMaximum = true;
          }
          id++;
        } else {
          if (!that.form.vehicles[that.vehicleStepIndex].isVINValid) {
            let vinField = that.$el.querySelector(
              '[name="vin' + that.vehicleStepIndex + '"]'
            );
            if (vinField) {
              vinField.focus();
            }
            if (this.checkForDuplicateVIN(this.vehicleStepIndex)) {
              this.showSnackbarForDuplicateVin();
            }
          } else {
            let firstErrorField = that.$el.querySelector(
              '[name="' + that.$validator.errors.items[0].field + '"]'
            );
            if (firstErrorField) {
              firstErrorField.focus();
            }
          }
        }
      });
    },
    removeVehicle: function(index) {
      this.scrollToView();
      Vue.delete(this.form.vehicles, index);
      this.hasMaximum = false;
      this.vehicleStepIndex--;
    },

    submit() {
      let firstErrorField;

      return new Promise((resolve, reject) => {
        if (
          this.form.vehicles[this.vehicleStepIndex].miles > 13000 &&
          !this.mileageModalShown
        ) {
          this.mileageModalShown = true;
          this.showMileageModal = true;
          return;
        }
        this.$validator.validateAll().then(result => {
          if (result && this.form.vehicles[this.vehicleStepIndex].isVINValid) {
            let payload = {
              vehicles: _.cloneDeep(this.form.vehicles)
            };
            this.updateForm(payload);
            resolve(true);
          } else {
            if (!this.form.vehicles[this.vehicleStepIndex].isVINValid) {
              let vinField = this.$el.querySelector(
                '[name="vin' + this.vehicleStepIndex + '"]'
              );
              if (vinField) {
                vinField.focus();
              }
              if (this.checkForDuplicateVIN(this.vehicleStepIndex)) {
                this.showSnackbarForDuplicateVin();
              }
            } else {
              firstErrorField = this.$el.querySelector(
                '[name="' + this.$validator.errors.items[0].field + '"]'
              );
              if (firstErrorField) {
                firstErrorField.focus();
              }
            }
            reject('invalid fields');
          }
        });
      });
    },
    checkBusinessSelected(vehicle) {
      this.showWarningModal = false;
      if (vehicle.purpose && vehicle.purpose.value === 'Business') {
        this.showWarningModal = true;
        return true;
      }
      return false;
    },
    backButtonNavigation() {
      this.scrollToView();
      if (this.vehicleStepIndex > 0) {
        this.vehicleStepIndex--;
      } else {
        this.$emit('goBack');
      }
    },
    continueButtonNavigation() {
      let firstErrorField;
      if (
        this.checkBusinessSelected(this.form.vehicles[this.vehicleStepIndex])
      ) {
        return;
      }
      if (
        this.form.vehicles.length > 1 &&
        this.vehicleStepIndex < this.form.vehicles.length - 1
      ) {
        this.$validator.validateAll().then(result => {
          if (result) {
            if (this.checkForDuplicateVIN(this.vehicleStepIndex)) {
              this.form.vehicles[this.vehicleStepIndex].isVINValid = false;
              this.showSnackbarForDuplicateVin();
            } else {
              this.vehicleStepIndex++;
              if (this.form.vehicles[this.vehicleStepIndex].vin) {
                this.vinCheckAPI(this.vehicleStepIndex);
              }
            }
          } else {
            firstErrorField = this.$el.querySelector(
              '[name="' + this.$validator.errors.items[0].field + '"]'
            );
            if (firstErrorField) {
              firstErrorField.focus();
            }
          }
        });
      } else {
        this.fetchVehicleImage();
        this.$emit('nextButtonAction'); // trigger to next page
      }
    },
    fetchVehicleImage() {
      if (
        this.form.vehicles[0].vin &&
        this.form.vehicles[0].year &&
        this.form.vehicles[0].model
      ) {
        this.getVehicleImage({
          vin: this.form.vehicles[0].vin,
          year: this.form.vehicles[0].year,
          model: this.form.vehicles[0].model
        });
      }
    },
    scrollToView() {
      let container = document.getElementById('quote-container');
      setTimeout(() => {
        container.scrollIntoView(true);
      }, 100);
    },
    showSnackBar(options) {
      this.$snackbar.open(options);
    },
    checkForDuplicateVIN(index) {
      if (index !== 0) {
        let vinArray = this.form.vehicles.map((vehicle, iterationIndex) => {
          if (iterationIndex < index) {
            return vehicle.vin && vehicle.vin.toLowerCase();
          }
        });
        let currentVinNumber =
          this.form.vehicles[index].vin &&
          this.form.vehicles[index].vin.toLowerCase();
        let count = vinArray.reduce(function(n, val) {
          return n + (val === currentVinNumber);
        }, 0);
        return count > 0 ? true : false;
      }
    },
    showSnackbarForDuplicateVin() {
      this.showSnackBar({
        type: 'is-danger',
        message: 'Duplicate VIN',
        position: 'is-bottom'
      });
    },
    checkValueAmount(key, value, event) {
      if ((value && value.length && value.length >= 5) || event === 'blur') {
        let validator = this.$validator;
        validator.validate(key, value);
        if (
          key.includes('value-amount') &&
          value &&
          value.length &&
          value.length >= 8
        ) {
          // TODO: fix unused variable declaration
          // eslint-disable-next-line
          const amount = Number(value.toString().replace(/[^0-9]/g, ''));
        } else {
          this.disableContinueButton = false;
        }
      }
    },
    vinInput() {
      this.form.vehicles[this.vehicleStepIndex].vin = this.form.vehicles[
        this.vehicleStepIndex
      ].vin
        .replace(/[o,O]/g, '0')
        .replace(/[i,I]/g, '1');
    }
  }
};
</script>
<style lang="scss">
.vehicle,
.driver,
.quote-info {
  .input__field {
    margin-top: 1rem;
    min-height: 3rem;
    @media (min-width: 760px) {
      margin-top: 2.3rem;
      min-height: 3.7rem;
    }
  }
}
.vehicle {
  margin-bottom: 4rem;
  @media (max-width: 760px) {
    margin-bottom: 2rem;
  }
}

.value-amount-text {
  display: inline-block;
  margin-top: 10px;
  font-size: 16px;
  margin-top: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #737278;
}

.firstLabel {
  position: relative;
}

.textFieldLabel {
  position: absolute;
  margin-top: -1.3rem;
}
.primary-use-info-icon {
  position: absolute !important;
  top: 1.4rem;
  right: 1rem;
  color: #737278;
  .content {
    width: unset !important;
    min-width: 360px;
    display: none !important;
    justify-content: center;
    padding: 10px 0px !important;
    i {
      left: 72% !important;
      @media (max-width: 992px) and (min-width: 768px) {
        left: 80% !important;
      }
      @media (max-width: 768px) {
        left: 85% !important;
      }
    }
    @media (max-width: 768px) {
      min-width: 300px;
      padding: 10px !important;
    }
    @media (min-width: 992px) {
      left: -70px !important;
    }
    @media (max-width: 992px) {
      left: -100px !important;
    }
  }
  &:hover .content {
    display: flex !important;
  }
  @media (max-width: 760px) {
    top: 1rem;
    right: 0.7rem;
  }
}
.tool-tip {
  position: relative;
  display: inline-block;

  .content {
    box-sizing: border-box;
    color: #000;
    display: none;
    font-size: 14px;
    font-family: $family-sans-serif;
    line-height: 20px;
    padding: 18px;
    top: 40px;
    transform: translate(-50%, 0);
    background-color: $porcelain;
    position: absolute;
    z-index: 99999999;

    @media (max-width: 991px) {
      width: 450px;
      left: -170px;
    }
    @media (max-width: 760px) {
      left: -83px;
      width: 300px;
    }

    @media (min-width: 992px) {
      left: 50%;
      line-height: 1.5;
      font-size: 1rem;
      padding: 25px 30px;
      width: 450px;
    }

    i {
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-left: -20px;
      width: 40px;
      height: 20px;
      overflow: hidden;
      @media (max-width: 991px) {
        left: 402px;
      }
      @media (max-width: 760px) {
        left: 80%;
      }

      &::after {
        content: '';
        position: absolute;
        width: 20px;
        height: 20px;
        left: 50%;
        transform: translate(-50%, 50%) rotate(45deg);
        background-color: $porcelain;
      }
    }
  }

  &:hover .content {
    display: block;
  }
}
</style>
<style scoped lang="scss">
.div__field {
  color: #fff;
  background-color: $bombay;
  padding-top: 0rem !important;
  padding-bottom: 0rem !important;
  display: flex;
  align-items: center;
  margin-top: 1.8rem;
  font-size: 1rem;
  @media (min-width: 760px) {
    margin-top: 2.3rem;
  }
  @media (max-width: 767px) {
    font-size: 0.9rem;
  }
}
@media (max-width: 560px) {
  .quote-wizard .button-primary + .button-primary {
    &.another-vehicle-button {
      margin-left: 0;
      margin-top: 1rem;
    }
    &.remove-vehicle {
      margin-left: 0;
      margin-top: 1rem;
    }
  }
}
.vin-error-text {
  font-size: 12px;
  color: $red;
}
</style>
